import { render, staticRenderFns } from "./DataManagerGrid.vue?vue&type=template&id=522adc9c&"
import script from "./DataManagerGrid.vue?vue&type=script&lang=js&"
export * from "./DataManagerGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports